import { call } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga/effects';

import { types as contactTypes, actions as contactActions } from 'ducks/supplierEnquiry/supplierContacts';

import { callApi } from '../utils';
import * as api from 'api/supplierEnquiry/contact';


function* search(action) {
  const { success, failure } = contactActions.saga.searchContact;
  yield callApi(
    call(api.search, action.data),
    success,
    failure
  )
}

function* searchById(action) {
  const { success, failure } = contactActions.saga.searchContactById;

  yield callApi(
    call(api.searchById, action.data),
    success,
    failure
  )
}
export default function* rootCustomerSaga() {
  yield takeLatest(contactTypes.searchContact, search)
  yield takeLatest(contactTypes.searchContactById, searchById)
}